{
  "REPORT": {
    "HEADER": "Razgovori",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Još nemamo dovoljno podataka za izradu izvještaja. Pokušajte ponovno kasnije.",
    "DOWNLOAD_AGENT_REPORTS": "Preuzmi izvještaje agenata",
    "DATA_FETCHING_FAILED": "Dohvaćanje podataka nije uspjelo. Pokušajte ponovno kasnije.",
    "SUMMARY_FETCHING_FAILED": "Dohvaćanje sažetka nije uspjelo. Pokušajte ponovno kasnije.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vrijeme prvog odgovora",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme prvog odgovora je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vrijeme rješavanja",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme rješavanja je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rješavanja",
        "DESC": "( Ukupno )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Broj rješavanja",
        "DESC": "( Ukupno )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Broj predaja agentu",
        "DESC": "( Ukupno )"
      },
      "REPLY_TIME": {
        "NAME": "Vrijeme čekanja kupca",
        "TOOLTIP_TEXT": "Vrijeme čekanja je {metricValue} (na temelju odgovora: {conversationCount})",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Danas",
      "YESTERDAY": "Jučer",
      "LAST_7_DAYS": "Zadnjih 7 dana",
      "LAST_30_DAYS": "Zadnjih 30 dana",
      "THIS_MONTH": "Ovaj mjesec",
      "LAST_MONTH": "Prošli mjesec",
      "LAST_3_MONTHS": "Zadnja 3 mjeseca",
      "LAST_6_MONTHS": "Zadnjih 6 mjeseci",
      "LAST_YEAR": "Prošla godina",
      "CUSTOM_DATE_RANGE": "Prilagođeno razdoblje"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primijeni",
      "PLACEHOLDER": "Odaberi razdoblje"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupiraj po",
    "DURATION_FILTER_LABEL": "Trajanje",
    "GROUPING_OPTIONS": {
      "DAY": "Dan",
      "WEEK": "Tjedan",
      "MONTH": "Mjesec",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Radno vrijeme",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Poništi filtar",
      "EMPTY_LIST": "Nisu pronađeni rezultati"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Razgovori: {count}",
      "RESULT_COUNT_MESSAGE": "Poruke: {count}",
      "EMPTY": "Nema zapisa za ovaj stupac.",
      "ERROR": "Zapise nije moguće učitati. Pokušajte ponovno.",
      "LOAD_MORE": "Učitaj više",
      "PREVIOUS_BUCKET": "Prethodni stupac",
      "NEXT_BUCKET": "Sljedeći stupac",
      "UNKNOWN_CONTACT": "Nepoznat kontakt",
      "UNKNOWN_INBOX": "Nepoznat sandučić",
      "UNASSIGNED_AGENT": "Nedodijeljeno",
      "NO_MESSAGE_CONTENT": "Poruka nema sadržaja",
      "MESSAGE_CREATED_AT": "Poruka stvorena {time}",
      "EVENT_OCCURRED_AT": "Događaj se dogodio {time}",
      "INCOMING_MESSAGE": "Dolazna poruka",
      "OUTGOING_MESSAGE": "Odlazna poruka",
      "VIEW_ALL": "Prikaži u razgovorima",
      "VIEW_ALL_LIMIT": "U popisu razgovora otvaraju se samo stupci s najviše {limit} razgovora.",
      "HIDDEN_COUNT": "Nije prikazano jer niste član njihova sandučića: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Prikaz {start} – {end} od {total} rezultata",
      "PER_PAGE_TEMPLATE": "{size} / stranica"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Pregled agenata",
    "DESCRIPTION": "Pratite uspješnost agenata pomoću ključnih metrika: razgovori, vrijeme odgovora, vrijeme rješavanja i riješeni slučajevi. Kliknite ime agenta za više detalja.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Još nemamo dovoljno podataka za izradu izvještaja. Pokušajte ponovno kasnije.",
    "DOWNLOAD_AGENT_REPORTS": "Preuzmi izvještaje agenata",
    "FILTER_DROPDOWN_LABEL": "Odaberi agenta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vrijeme prvog odgovora",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme prvog odgovora je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vrijeme rješavanja",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme rješavanja je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rješavanja",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primijeni",
      "PLACEHOLDER": "Odaberi razdoblje"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Pregled oznaka",
    "DESCRIPTION": "Pratite učinkovitost oznaka pomoću ključnih metrika, uključujući razgovore, vrijeme odgovora, vrijeme rješavanja i riješene slučajeve.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Još nemamo dovoljno podataka za izradu izvještaja. Pokušajte ponovno kasnije.",
    "DOWNLOAD_LABEL_REPORTS": "Preuzmi izvještaje oznaka",
    "FILTER_DROPDOWN_LABEL": "Odaberi oznaku",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vrijeme prvog odgovora",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme prvog odgovora je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vrijeme rješavanja",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme rješavanja je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rješavanja",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primijeni",
      "PLACEHOLDER": "Odaberi razdoblje"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Pregled sandučića",
    "DESCRIPTION": "Brzo pregledajte uspješnost sandučića pomoću ključnih metrika: razgovori, vrijeme odgovora, vrijeme rješavanja i riješeni slučajevi, sve na jednom mjestu. Kliknite naziv sandučića za više detalja.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Još nemamo dovoljno podataka za izradu izvještaja. Pokušajte ponovno kasnije.",
    "DOWNLOAD_INBOX_REPORTS": "Preuzmi izvještaje sandučića",
    "FILTER_DROPDOWN_LABEL": "Odaberi sandučić",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vrijeme prvog odgovora",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme prvog odgovora je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vrijeme rješavanja",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme rješavanja je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rješavanja",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primijeni",
      "PLACEHOLDER": "Odaberi razdoblje"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Pregled timova",
    "DESCRIPTION": "Pregledajte uspješnost tima pomoću ključnih metrika: razgovori, vrijeme odgovora, vrijeme rješavanja i riješeni slučajevi. Kliknite naziv tima za više detalja.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Još nemamo dovoljno podataka za izradu izvještaja. Pokušajte ponovno kasnije.",
    "DOWNLOAD_TEAM_REPORTS": "Preuzmi izvještaje timova",
    "FILTER_DROPDOWN_LABEL": "Odaberi tim",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vrijeme prvog odgovora",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme prvog odgovora je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vrijeme rješavanja",
        "DESC": "( Prosjek )",
        "INFO_TEXT": "Ukupan broj razgovora korištenih za izračun:",
        "TOOLTIP_TEXT": "Vrijeme rješavanja je {metricValue} (na temelju razgovora: {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rješavanja",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primijeni",
      "PLACEHOLDER": "Odaberi razdoblje"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT izvještaji",
    "NO_RECORDS": "Nema dostupnih odgovora na CSAT anketu.",
    "DOWNLOAD": "Preuzmi CSAT izvještaje",
    "DOWNLOAD_FAILED": "Preuzimanje CSAT izvještaja nije uspjelo",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Odaberi agente"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Dodijeljeni agent",
        "RATING": "Ocjena",
        "FEEDBACK_TEXT": "Komentar povratne informacije"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Ukupno odgovora",
        "TOOLTIP": "Ukupan broj prikupljenih odgovora"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Ocjena zadovoljstva",
        "TOOLTIP": "Ukupan broj pozitivnih odgovora / Ukupan broj odgovora * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Stopa odgovora",
        "TOOLTIP": "Ukupan broj odgovora / Ukupan broj poslanih poruka s CSAT anketom * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Izvještaji bota",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Broj razgovora",
        "TOOLTIP": "Ukupan broj razgovora s porukama bota"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Broj odgovora",
        "TOOLTIP": "Ukupan broj odlaznih poruka"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Broj AI odgovora",
        "TOOLTIP": "Ukupan broj poruka s odgovorima koje je poslao bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Broj pripremljenih odgovora",
        "TOOLTIP": "Ukupan broj copilot prijedloga koje je bot pripremio za agente"
      },
      "SUCCESS_RATE": {
        "LABEL": "Riješeno AI-em",
        "TOOLTIP": "Postotak razgovora riješenih AI-em bez predaje agentu"
      },
      "RESOLVE_TIME": {
        "LABEL": "Vrijeme rješavanja",
        "TOOLTIP": "Srednje vrijeme od prve poruke korisnika do zadnje poruke bota/agenta"
      }
    },
    "GROUP_BY": {
      "LABEL": "Grupiraj po",
      "NONE": "Ne grupiraj",
      "INBOXES": "Sandučići",
      "LABELS": "Oznake"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribucija po grupama",
      "BACK_TO_ALL": "Prikaži sve",
      "TABLE": {
        "INBOX": "Sandučić",
        "LABEL": "Oznaka",
        "CONVERSATIONS": "Razgovori",
        "MESSAGES": "Poruke",
        "MESSAGES_TOOLTIP": "Ukupan broj odlaznih poruka",
        "AI_MESSAGES": "AI odgovori",
        "AI_MESSAGES_TOOLTIP": "Ukupan broj AI odgovora, nakon čega slijedi broj pozitivnih i negativnih ocjena krajnjih korisnika",
        "THUMBS_UP_TOOLTIP": "Broj AI odgovora koje su krajnji korisnici ocijenili pozitivno (palac gore)",
        "THUMBS_DOWN_TOOLTIP": "Broj AI odgovora koje su krajnji korisnici ocijenili negativno (palac dolje)",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Postotak AI odgovora od svih poruka u ovoj grupi",
        "PREPARED": "Pripremljeni odgovori",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Postotak poruka od svih poruka u ovoj grupi",
        "BOT_RESPONSES": "AI odgovori %",
        "SUGGESTION_USED": "Korišteni odgovori",
        "SUGGESTION_USED_TOOLTIP": "Postotak pripremljenih odgovora u ovoj grupi koje su agenti koristili",
        "SUGGESTION_NOT_USED": "Nekorišteni odgovori",
        "SUGGESTION_NOT_USED_TOOLTIP": "Postotak poruka u ovoj grupi koje su imale pripremljen odgovor, ali on nije korišten"
      },
      "NOTES": {
        "TITLE": "Kako se izračunavaju metrike",
        "CONVERSATIONS": "Broj razgovora koji imaju najmanje jednu odlaznu poruku u odabranom razdoblju.",
        "MESSAGES": "Ukupan broj odlaznih (nepovatnih) poruka poslanih u odabranom razdoblju. Ovo uključuje i AI-generirane i ljudski napisane poruke.",
        "PERCENTAGE": "Udio poruka ove grupe od svih odlaznih poruka u svim grupama.",
        "AI_MESSAGES": "Broj odlaznih poruka koje je AI bot poslao automatski (ne uključujući pripremljene odgovore za agente). Brojevi u zagradama pokazuju koliko su tih odgovora krajnji korisnici ocijenili pozitivno (palac gore) i negativno (palac dolje).",
        "BOT_RESPONSES_PCT": "Udio AI odgovora ove grupe od svih odlaznih poruka u ovoj grupi.",
        "PREPARED": "Broj copilot prijedloga (pripremljenih odgovora) koje je AI bot generirao za agente u odabranom razdoblju. Ovo su privatne poruke vidljive samo agentima i ne računaju se kao odlazne poruke, pa se ovaj broj možda ne podudara sa stupcem Poruke.",
        "SUGGESTION_USED": "Postotak pripremljenih odgovora u ovoj grupi koje su agenti koristili. Ovo se možda ne podudara s brojem pripremljenih odgovora jer može uključivati prijedloge generirane u prethodnim razdobljima.",
        "SUGGESTION_NOT_USED": "Postotak odlaznih poruka u ovoj grupi gdje je copilot prijedlog bio dostupan, ali je agent odgovorio bez njegove upotrebe. Broji se samo kada je agent stvarno poslao odgovor. Ovo se možda ne podudara s brojem pripremljenih odgovora jer može uključivati prijedloge generirane u prethodnim razdobljima."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Pregled",
    "LIVE": "Uživo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Otvoreni razgovori",
      "LOADING_MESSAGE": "Učitavanje metrika razgovora...",
      "OPEN": "Otvoreni",
      "UNATTENDED": "Neobrađeni",
      "UNASSIGNED": "Nedodijeljeni",
      "PENDING": "Na čekanju"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Promet razgovora",
      "NO_CONVERSATIONS": "Nema razgovora",
      "CONVERSATION": "{count} razgovor",
      "CONVERSATIONS": "Razgovora: {count}",
      "DOWNLOAD_REPORT": "Preuzmi izvještaj"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Razgovori po agentima",
      "LOADING_MESSAGE": "Učitavanje metrika agenata...",
      "NO_AGENTS": "Nema razgovora po agentima",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otvoreni",
        "UNATTENDED": "Neobrađeni",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Svi timovi",
      "HEADER": "Razgovori po timovima",
      "LOADING_MESSAGE": "Učitavanje metrika timova...",
      "NO_TEAMS": "Nema dostupnih podataka",
      "TABLE_HEADER": {
        "TEAM": "Tim",
        "OPEN": "Otvoreni",
        "UNATTENDED": "Neobrađeni",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Status agenata",
      "ONLINE": "Dostupan",
      "BUSY": "Zauzet",
      "OFFLINE": "Nedostupan"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Nedjelja",
    "MONDAY": "Ponedjeljak",
    "TUESDAY": "Utorak",
    "WEDNESDAY": "Srijeda",
    "THURSDAY": "Četvrtak",
    "FRIDAY": "Petak",
    "SATURDAY": "Subota"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA izvještaji",
    "NO_RECORDS": "Nema razgovora s primijenjenim SLA-om.",
    "LOADING": "Učitavanje SLA podataka...",
    "DOWNLOAD_SLA_REPORTS": "Preuzmi SLA izvještaje",
    "DOWNLOAD_FAILED": "Preuzimanje SLA izvještaja nije uspjelo",
    "DROPDOWN": {
      "ADD_FIlTER": "Dodaj filter",
      "CLEAR_ALL": "Poništi sve",
      "CLEAR_FILTER": "Poništi filtar",
      "EMPTY_LIST": "Nisu pronađeni rezultati",
      "NO_FILTER": "Nema dostupnih filtara",
      "SEARCH": "Pretraži filtre",
      "INPUT_PLACEHOLDER": {
        "SLA": "Naziv SLA-a",
        "AGENTS": "Ime agenta",
        "INBOXES": "Naziv sandučića",
        "LABELS": "Naziv oznake",
        "TEAMS": "Naziv tima"
      },
      "SLA": "SLA pravilo",
      "INBOXES": "Sandučić",
      "AGENTS": "Agent",
      "LABELS": "Oznaka",
      "TEAMS": "Tim"
    },
    "WITH": "s",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Stopa ispunjenja",
        "TOOLTIP": "Postotak izrađenih SLA-ova koji su uspješno ispunjeni"
      },
      "NO_OF_MISSES": {
        "LABEL": "Broj prekoračenja",
        "TOOLTIP": "Ukupan broj SLA prekoračenja u odabranom razdoblju"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Broj razgovora",
        "TOOLTIP": "Ukupan broj razgovora sa SLA-om"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Pravilo",
        "CONVERSATION": "Razgovor",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Prikaži detalje"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Međuzbroj",
    "NO_TEAM": "Bez tima",
    "GROUP_BY_TEAMS": "Grupiraj po timovima",
    "INBOX": "Sandučić",
    "AGENT": "Agent",
    "TEAM": "Tim",
    "LABEL": "Oznaka",
    "TOTAL": "Ukupno",
    "AVG_RESOLUTION_TIME": "Prosj. vrijeme rješavanja",
    "AVG_FIRST_RESPONSE_TIME": "Prosj. vrijeme prvog odgovora",
    "AVG_REPLY_TIME": "Prosj. vrijeme čekanja kupca",
    "RESOLUTION_COUNT": "Broj rješavanja",
    "CONVERSATIONS": "Broj razgovora",
    "OUTGOING_CHATS": "Odlazni chatovi",
    "OUTGOING_EMAILS": "Odlazni e-mailovi",
    "PHONE_CALLS": "Telefonski pozivi",
    "INBOUND_CALLS": "Dolazni pozivi",
    "OUTBOUND_CALLS": "Odlazni pozivi",
    "TOTAL_ACTIVITIES": "Ukupno aktivnosti",
    "ONLINE_TIME": "Vrijeme online",
    "QUEUE_AVAILABLE_TIME": "Vrijeme dostupnosti u redu čekanja",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Broj odlaznih poruka koje je poslao ovaj agent",
      "OUTGOING_EMAILS": "Broj odlaznih e-mailova koje je poslao ovaj agent",
      "PHONE_CALLS": "Ukupan broj telefonskih poziva dodijeljenih ovom agentu (zbroj dolaznih i odlaznih poziva)",
      "TOTAL_ACTIVITIES": "Ukupan broj aktivnosti: dolazni pozivi + odlazni pozivi + odlazni chatovi + odlazni e-mailovi",
      "INBOUND_CALLS": "Broj dolaznih telefonskih poziva dodijeljenih ovom agentu",
      "OUTBOUND_CALLS": "Broj odlaznih telefonskih poziva dodijeljenih ovom agentu",
      "AVG_FIRST_RESPONSE_TIME": "Prosječno vrijeme od kreiranja razgovora do prvog odgovora agenta u razgovorima dodijeljenim ovom agentu",
      "AVG_RESOLUTION_TIME": "Prosječno vrijeme od kreiranja razgovora do rješavanja u razgovorima dodijeljenim ovom agentu",
      "AVG_REPLY_TIME": "Prosječno vrijeme koje korisnici čekaju između svoje poruke i odgovora agenta u razgovorima dodijeljenim ovom agentu",
      "ONLINE_TIME": "Ukupno vrijeme koje je agent bio online ili zauzet tijekom odabranog razdoblja",
      "QUEUE_AVAILABLE_TIME": "Ukupno vrijeme koje je agent bio dostupan u telefonskim redovima čekanja tijekom odabranog razdoblja"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Izvještaji telefona",
    "DESCRIPTION": "Pratite metrike telefonskih poziva s detaljnim uvidima u dolazne i odlazne pozive, grupirano po agentu ili sandučiću za sveobuhvatnu analizu.",
    "AGENT_HEADER": "Izvještaji telefona - po agentu",
    "INBOX_HEADER": "Izvještaji telefona - po sandučiću",
    "DOWNLOAD_BUTTON": "Preuzmi izvještaje telefona",
    "DOWNLOAD_PHONE_REPORTS": "Preuzmi izvještaje telefona",
    "GROUP_BY": {
      "LABEL": "Grupiraj po",
      "AGENT": "Agent",
      "INBOX": "Sandučić"
    },
    "TABLE": {
      "AGENT_NAME": "Ime agenta",
      "INBOX_NAME": "Naziv sandučića",
      "TOTAL_CALLS": "Ukupno",
      "INBOUND_CALLS": "Dolazni",
      "OUTBOUND_CALLS": "Odlazni",
      "FAILED_OUTBOUND_CALLS": "Neuspješni odlazni",
      "AVG_AGENT_HANDLED_DURATION": "Prosj. trajanje",
      "TOTAL_AGENT_HANDLED_DURATION": "Ukupno trajanje",
      "AVG_RINGING_TIME": "Prosj. vrijeme zvonjenja",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Uspješnost %",
      "UNIQUE_CALLERS": "Jedinstveni pozivatelji",
      "UNIQUE_CALLED_CONTACTS": "Jedinstveno zvani",
      "UNANSWERED_MISSED_CALLS": "Propušteni bez praćenja",
      "UNANSWERED_MISSED_PERCENTAGE": "Neodgovoreno propušteni %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Propušteni bez praćenja, nedovoljno nazvani natrag",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Propušteni bez praćenja, nedovoljno nazvani natrag %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Ukupan broj svih poziva (uključujući nespojene)",
      "INBOUND_CALLS": "Broj spojenih poziva",
      "OUTBOUND_CALLS": "Broj svih odlaznih poziva (uključujući nespojene)",
      "FAILED_OUTBOUND_CALLS": "Broj odlaznih poziva koji se nisu uspjeli spojiti",
      "AVG_AGENT_HANDLED_DURATION": "Prosječno trajanje poziva koje su obradili agenti",
      "TOTAL_AGENT_HANDLED_DURATION": "Ukupno trajanje svih poziva koje su obradili agenti",
      "AVG_RINGING_TIME": "Prosječno vrijeme koje su pozivi proveli zvoneći prije nego što su odgovoreni",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Postotak odlaznih poziva koji su se uspješno spojili",
      "UNIQUE_CALLERS": "Broj jedinstvenih kontakata koji su uputili dolazne pozive",
      "UNIQUE_CALLED_CONTACTS": "Broj jedinstvenih kontakata koji su nazvani putem odlaznih poziva",
      "UNANSWERED_MISSED_CALLS": "Broj propuštenih poziva gdje nije uspostavljeno uspješno pozivanje natrag (poziv je spojen). Može uključivati pozive koji još mogu biti obrađeni tijekom radnog dana",
      "UNANSWERED_MISSED_PERCENTAGE": "Postotak jedinstvenih pozivatelja čiji su pozivi propušteni bez praćenja (neodgovoreni propušteni pozivi / jedinstveni pozivatelji)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Broj propuštenih poziva s manje od 2 pokušaja pozivanja natrag. Može uključivati pozive koji još mogu biti obrađeni tijekom radnog dana",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Postotak jedinstvenih pozivatelja s manje od 2 pokušaja pozivanja natrag ((propušteni bez praćenja - dovoljno obrađeni) / jedinstveni pozivatelji)"
    },
    "EMPTY_STATE": {
      "TITLE": "Nema dostupnih podataka o telefonskim pozivima",
      "MESSAGE": "Nema telefonskih poziva u odabranom rasponu datuma. Pokušajte prilagoditi filtere ili raspon datuma."
    }
  }
}
